export enum FeatureToggle {
  catalogHealth = 'rt_ipp_catalog_health',
}
